import { Component, Input, OnChanges, OnInit, SimpleChanges, ChangeDetectorRef, OnDestroy } from '@angular/core';
import { ActivatedRoute, NavigationEnd, Params, Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { MaintainTabDTO, MenuDTO } from '../../../../../system/system-dtos';
import { DataSource } from '../../data-source/data-source';

@Component({
  selector: 'app-maintain-table-tabs',
  templateUrl: './maintain-table-tabs.component.html',
  styleUrls: ['./maintain-table-tabs.component.scss'],
  standalone: false,
})
export class MaintainTableTabsComponent implements OnInit, OnChanges, OnDestroy {
  @Input() tabs: MaintainTabDTO[];

  @Input() menuConfig: MenuDTO;

  @Input() dataSource: DataSource;

  @Input() mode: number;

  public tabsWithCount: { [p: string]: number };

  public initialIndex = 0;

  private subscription: Subscription;

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private changeDetectorRef: ChangeDetectorRef
  ) {}

  ngOnInit() {
    this.handleSubscription();

    this.determineIndex();
    this.router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        this.handleSubscription();
        this.determineIndex();
      }
    });
  }

  private handleSubscription() {
    this.tabsWithCount = null;
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
    this.subscription = this.dataSource
      .getTabsWithCount(this.menuConfig)
      .subscribe((value: { [p: string]: number }) => {
        this.tabsWithCount = value;

        if (!this.changeDetectorRef['destroyed']) {
          this.changeDetectorRef.detectChanges();
        }
      });
  }

  navigateToTab(tab: MaintainTabDTO) {
    const params: Params = this.route.snapshot.queryParams;

    this.router.navigate([], {
      relativeTo: this.route,
      queryParams: {
        cohortId: params.cohortId,
        tab: tab.tableView.code,
        _mode: this.mode,
      },
      replaceUrl: true,
    });
  }

  ngOnChanges(changes: SimpleChanges): void {
    this.handleSubscription();
    this.ngOnInit();
  }

  determineIndex() {
    this.initialIndex = this.tabs
      ? this.tabs.findIndex((t) => t.tableView.code === this.route.snapshot.queryParamMap.get('tab'))
      : 0;
  }

  navigate($event) {
    this.navigateToTab(this.tabs[$event]);
  }

  ngOnDestroy(): void {
    this.changeDetectorRef.detach();
    this.subscription.unsubscribe();
  }
}
